import { ReactNode } from 'react'

type WidgetGridProps = {
  children: ReactNode
  className?: string
}

export const WidgetGrid = ({
  children,
  className = '',
}: WidgetGridProps) => (
  <div className={`row g-3 align-items-stretch ${className}`}>
    {children}
  </div>
)
